module.exports = __webpack_public_path__ + "0393026a2c00da83bd215abf8bd2434b.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/LU.svg
// module id = eIc2
// module chunks = 0